<template>
  <el-select v-model="id" :size="size" :clearable="clearable" :disabled="disabled" :multiple="multiple" placeholder="请选择" :remote-method="remoteMethod" :loading="loading" @change="selectChange">
    <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.type">
      <span>{{ item.name}}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: "",
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      list: [],
      id: "",
      loading: false,
    }
  },
  created() {
    this.id = this.value;
  },
  mounted() {
    this.remoteMethod(this.value);
  },
  watch: {
    value: function (newValue) {
      this.id = newValue;
    }
  },
  methods: {
    remoteMethod(query) {
      this.list = [
        { id: "1", name: "精品", type: 1 },
        { id: "2", name: "标准", type: 2 },
        // { id: "3", name: "平常", type: 3 },
        { id: "4", name: "一般", type: 4 },
      ]
    },
    selectChange(val) {
      this.$emit('input', val);
      if (!this.multiple) {
        let obj = this.list.find(item => val == item.type);
        this.$emit('change', obj);
      } else {
        let list = this.list.filter(item => val.indexOf(item.type) >= 0);
        this.$emit('change', list);
      }
    },
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/PaperLevels.vue